import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Button,
  TextField,
  Typography,
  makeStyles,
  Theme,
  useTheme,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CancelIcon from "@material-ui/icons/Cancel";
import SendIcon from "@material-ui/icons/Send";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Grow from "@material-ui/core/Grow/Grow";
import { licenceService } from "../../services/licenceService";
import { NpuError } from "../../models/error.model";

import CloseIcon from "@material-ui/icons/Close";
import { withSnackbar, useSnackbar } from "notistack";

const useStyles = makeStyles((theme: Theme) => ({
  backDrop: {
    backdropFilter: "blur(7px)",
    backgroundColor: `${theme.palette.grey[100]}30`,
  },
}));

const AddLicense = (props: any) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const cancelAction = () => {
    return (
      <IconButton onClick={() => closeSnackbar()}>
        <CloseIcon fontSize="small" />
      </IconButton>
    );
  };

  const [open, setOpen] = React.useState(false);

  const [newLicense, setNewLicense] = useState({
    licence: 0,
    name: "",
    fio: "",
    contacts: "",
  });

  const handleChange = (name: any, value: any) => {
    if (name === "licence") {
      const licenceNumber = Number(value.trim().replace(/\D/gim, ""));
      setNewLicense((oldValue: any) => ({
        ...oldValue,
        licence: licenceNumber,
      }));
    }
    if (name === "pib") {
      setNewLicense((oldValue: any) => ({ ...oldValue, fio: value }));
    }

    if (name === "position") {
      setNewLicense((oldValue: any) => ({ ...oldValue, name: value }));
    }

    if (name === "contacts") {
      setNewLicense((oldValue: any) => ({ ...oldValue, contacts: value }));
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    // console.log("open : ", open);
  };

  const handleClose = () => {
    setOpen(false);

    setNewLicense({
      licence: 0,
      name: "",
      fio: "",
      contacts: "",
    });
  };

  const sendNewLicense = () => {
    const reqData = {
      licence: newLicense.licence,
      name: newLicense.name,
      fio: newLicense.fio,
      contacts: newLicense.contacts,
    };
    licenceService
      .addLicence(reqData)
      .then(() => handleClose())
      .then(() => props.getUpdateLicences())
      .catch((e: NpuError) =>
        enqueueSnackbar(e.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
          action: cancelAction,
        })
      );
  };

  return (
    <>
      <Grow in>
        <Grid>
          <IconButton
            onClick={handleClickOpen}
            color="primary"
            style={{ width: 80, height: 80 }}
          >
            <AddCircleIcon fontSize="large" style={{ width: 60, height: 60 }} />
          </IconButton>
        </Grid>
      </Grow>

      <Grid container item xs={12} justify="center">
        <Dialog
          BackdropProps={{
            classes: {
              root: classes.backDrop,
            },
            timeout: 400,
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          {/* <DialogTitle id="form-dialog-title">{t("help.label")}</DialogTitle> */}
          <DialogTitle
            id="form-dialog-title"
            style={{ backgroundColor: theme.palette.grey[900] }}
          >
            {t("licences.modalTitle")}
          </DialogTitle>
          <DialogContent
            dividers={true}
            style={{ backgroundColor: theme.palette.grey[900] }}
            id="scroll-dialog-description"
            tabIndex={-1}
          >
            {/* <DialogContentText>{t("betaTest.titleFeedback")}</DialogContentText>   */}
            <Grid container item xs={12} style={{ width: "850px" }}>
              <TextField
                required
                error={newLicense.licence < 1}
                label={t("licences.licenceN")}
                name="licence"
                fullWidth
                margin="dense"
                variant="outlined"
                multiline
                rows={3}
                rowsMax="10"
                value={newLicense.licence}
                onChange={(e: any) =>
                  handleChange(e.target.name, e.target.value)
                }

                // inputProps={{ disabled: true }}
              />

              <TextField
                label={t("licences.pib")}
                name="pib"
                fullWidth
                margin="dense"
                variant="outlined"
                multiline
                rows={1}
                value={newLicense.fio}
                rowsMax="5"
                onChange={(e: any) =>
                  handleChange(e.target.name, e.target.value)
                }

                // inputProps={{ disabled: true }}
              />
              <TextField
                label={t("licences.name")}
                name="position"
                fullWidth
                margin="dense"
                variant="outlined"
                multiline
                rows={1}
                rowsMax="3"
                value={newLicense.name}
                onChange={(e: any) =>
                  handleChange(e.target.name, e.target.value)
                }

                // inputProps={{ disabled: true }}
              />

              <TextField
                label={t("licences.contacts")}
                name="contacts"
                fullWidth
                margin="dense"
                variant="outlined"
                multiline
                rows={3}
                rowsMax="10"
                value={newLicense.contacts}
                onChange={(e: any) =>
                  handleChange(e.target.name, e.target.value)
                }

                // inputProps={{ disabled: true }}
              />
            </Grid>
          </DialogContent>
          <DialogActions style={{ backgroundColor: theme.palette.grey[900] }}>
            <Grid container item xs={12} justify="space-between">
              <Grid>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  color="primary"
                  startIcon={<CancelIcon />}
                  style={{ minWidth: 180, margin: "5px 0px" }}
                >
                  <Typography>{t("btns.cancel")}</Typography>
                </Button>
              </Grid>
              <Grid>
                <Button
                  variant="contained"
                  onClick={sendNewLicense}
                  color="primary"
                  startIcon={<SendIcon />}
                  style={{ minWidth: 180, margin: "5px 0px" }}
                >
                  <Typography>{t("btns.send")}</Typography>
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};

export default withSnackbar(AddLicense);
